import { Button, Center, Container, Paper, Stack, Text, Title } from '@mantine/core';
import type { FC } from 'react';
import { useNavigate } from 'react-router';

import { useUserQuery } from '../../data/user/useUserQuery.ts';
import { useLogout } from '../../hooks/data/auth.ts';

export const WrongRole: FC = () => {
  const { data } = useUserQuery();
  const navigate = useNavigate();

  const { mutate: logout, isPending } = useLogout();

  const onLogoutButtonClick = () => {
    logout(undefined, {
      onSuccess: () => {
        void navigate('/auth/login');
      },
    });
  };

  return (
    <Container pt="xl" size="sm">
      <Paper p="xl" radius="md" shadow="xl">
        <Stack gap="lg">
          <Title order={2} ta="center">
            Access Restricted
          </Title>
          <Text>
            You are currently logged in, but your account doesn&apos;t have promoter access. My GoGigi is exclusively
            available to promoter accounts. This may occur if you&apos;re logged in with another account in a different
            browser tab.
          </Text>
          <Text>
            You&apos;re currently logged in as: <strong>{data?.email}</strong>.
          </Text>
          <Text>
            To continue using My GoGigi, please log out of your current account and log in with an authorized promoter
            account.
          </Text>
          <Center pt="lg">
            <Button color="red" loading={isPending} radius="xl" size="lg" onClick={() => onLogoutButtonClick()}>
              Log Out of Current Account
            </Button>
          </Center>
        </Stack>
      </Paper>
    </Container>
  );
};
